// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"fa725bdd","316":"9ce54d07","453":"ac3b31aa","597":"e0a3ba80"}[chunkId] + ".chunk.js";
};